import React from 'react';
import ReactDOM from 'react-dom/client';
import './scss/_index.scss';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.REACT_APP_ENV === 'development') {
  console.log('React App Environment: development');
}